import React, { useEffect, useMemo, useState } from 'react';
import { puantajApi } from '../../services/api';
import { Button } from '../../components/ui/button';
import { Calendar, ChevronLeft, ChevronRight, Clock } from 'lucide-react';

const MONTHS_TR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const WD_TR = ['PAZ', 'PZT', 'SAL', 'ÇAR', 'PER', 'CUM', 'CTS'];

const PuantajimPage = () => {
  const now = new Date();
  const [ym, setYm] = useState({ y: now.getFullYear(), m: now.getMonth() + 1 });
  const monthStr = `${ym.y}-${String(ym.m).padStart(2, '0')}`;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    puantajApi.me(monthStr).then((r) => setData(r.data?.data || null)).finally(() => setLoading(false));
  }, [monthStr]);

  const days = useMemo(() => {
    if (!data) return [];
    return Array.from({ length: data.days }, (_, i) => {
      const d = i + 1;
      const date = `${monthStr}-${String(d).padStart(2, '0')}`;
      const wd = WD_TR[new Date(ym.y, ym.m - 1, d).getDay()];
      return { d, date, wd, cell: data.cells?.[date] };
    });
  }, [data, ym, monthStr]);

  const prev = () => setYm(({ y, m }) => (m === 1 ? { y: y - 1, m: 12 } : { y, m: m - 1 }));
  const next = () => setYm(({ y, m }) => (m === 12 ? { y: y + 1, m: 1 } : { y, m: m + 1 }));

  return (
    <div className="max-w-3xl mx-auto py-6">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Calendar className="h-6 w-6 text-blue-600" />
          <div>
            <h1 className="text-xl font-bold text-slate-900">Puantajım</h1>
            <p className="text-xs text-slate-500">{data?.personnel?.name} {data?.personnel?.unvan ? `· ${data.personnel.unvan}` : ''}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={prev}><ChevronLeft className="h-4 w-4" /></Button>
          <span className="font-semibold text-slate-800 w-32 text-center text-sm">{MONTHS_TR[ym.m - 1]} {ym.y}</span>
          <Button variant="outline" size="sm" onClick={next}><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>

      {!data?.personnel ? (
        <p className="text-center text-slate-400 py-12">Hesabınıza bağlı personel kaydı bulunamadı.</p>
      ) : (
        <>
          <div className="bg-blue-600 text-white rounded-xl p-4 mb-5 flex items-center justify-between">
            <div className="flex items-center gap-2"><Clock className="h-5 w-5" /><span className="text-sm">Toplam Mesai</span></div>
            <span className="text-2xl font-bold">{data.total_hours} saat</span>
          </div>

          {loading ? (
            <p className="text-center text-slate-400 py-8">Yükleniyor...</p>
          ) : (
            <div className="grid grid-cols-7 gap-1.5">
              {days.map((d) => (
                <div
                  key={d.d}
                  className={`rounded-lg p-1.5 text-center min-h-[52px] border ${d.cell ? 'border-transparent text-white' : 'border-slate-200 text-slate-300'}`}
                  style={d.cell ? { backgroundColor: d.cell.color } : {}}
                >
                  <div className="text-[10px] opacity-80">{d.d} {d.wd}</div>
                  {d.cell && <div className="text-xs font-bold mt-1">{d.cell.code}</div>}
                  {d.cell && (
                    <div className="text-[9px] opacity-90">
                      {d.cell.actual_hours != null && d.cell.actual_hours > 0 ? `${d.cell.actual_hours}s` : `${d.cell.hours}s`}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PuantajimPage;
